import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  readonly state$: Observable<boolean>;
  private readonly _state$: BehaviorSubject<boolean>;
  private renderer2: Renderer2;

  constructor(rendererFactory2: RendererFactory2) {
    this._state$ = new BehaviorSubject(false);
    this.state$ = this._state$.asObservable();
    this.renderer2 = rendererFactory2.createRenderer(null, null);
  }

  private setState(state): void {
    this._state$.next(state);
    // Set class on the html to handle overflow when the loader is open
    (this._state$.getValue() ? this.renderer2.addClass : this.renderer2.removeClass).call(this.renderer2, document.querySelector('html'), 'loader-open');
  }

  show() {
    if (!this._state$.getValue()) {
      this.setState(true);
    }
  }

  async showIn(ms) {
    if (!this._state$.getValue()) {
      await new Promise(resolve => setTimeout(resolve, ms));
      this.setState(true);
    }
  }

  hide() {
    if (this._state$.getValue()) {
      this.setState(false);
    }
  }

  async hideIn(ms) {
    if (this._state$.getValue()) {
      await new Promise(resolve => setTimeout(resolve, ms));
      this.setState(false);
    }
  }
}
